import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import { Paper, Box, Typography, Divider } from '@mui/material';
import * as yup from 'yup';
import { useFormik } from 'formik';
import UserList from '../../components/goalsetting/UserList';
import UserListBox from '../../components/goalsetting/UserListBox';
import * as deptApi from '../../lib/api/department';


const UserListContainer = () => {
    const { deptId } = useParams();
    let navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [employees, setEmployees] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState("usrNm")
    const [searchWords, setSearchWords] = useState("");


    useEffect(() => {
        if (deptId) {
            setSearchKeyword('usrNm');
            setSearchWords("");
            onLoadData();
        }
    }, [deptId])

    useEffect(() => {
        onLoadData();
    }, [searchKeyword, searchWords])


    const onLoadData = async () => {
        setLoading(true);
        let searchData = {
            roleTyp: 'SALES',
            [searchKeyword]: searchWords
        }

        try {
            const res = await deptApi.getEmpsByDepart(deptId, searchData);
            if (res.data.list) {
                setEmployees(res.data.list);
            }
        } catch (err) {
            let message =
                typeof err.response !== 'undefined'
                    ? err.response.data.message
                    : err.message;
            setError(err);
            enqueueSnackbar(message, {
                variant: 'error',
            });
        }
        setLoading(false);
    }



    const validationSchema = yup.object({
        searchKeyword: yup.string('').nullable(),
        searchWords: yup.string('').trim().nullable(),
    });

    const formik = useFormik({
        initialValues: {
            searchKeyword: "usrNm",
            searchWords: "",
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting }) => {
            setSubmitting(true);

            setSearchKeyword(values.searchKeyword);
            setSearchWords(values.searchWords);
            setSubmitting(false);
        },
    });


    if (error) {
        return <div>에러가 발생하였습니다. 관리자에게 문의하여 주십시오.</div>
    }

    if (loading || !employees) {
        return null;
    }


    return (
        <Paper>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    backgroundColor: '#424242',
                    color: '#fff',
                    py: 1,
                    px: 2,
                }}
            >
                <Typography variant="subtitle2" component="div">
                    사원 리스트
                </Typography>
            </Box>
            <Divider />
            <Box sx={{
                width: '400px'
            }}>
                <UserListBox formik={formik} />
                <UserList employees={employees} loading={loading} deptId={deptId} />
            </Box>
        </Paper>
    )
}

export default UserListContainer